import apiClient from './apiClient';

const THEME_STORAGE_KEY = 'pokosimoTheme';

export const THEME_OPTIONS = [
    { value: 'default', label: 'Rdeča (privzeta)', accent: '#dd2a2a' },
    { value: 'blue', label: 'Modra', accent: '#0066cc' },
    { value: 'black', label: 'Črna (temen naglas)', accent: '#000000' },
    { value: 'white', label: 'Bela (inverzna)', accent: '#ffffff' }
];

const isBrowser = () => typeof window !== 'undefined';

export function getStoredTheme() {
    if (!isBrowser()) return 'default';
    try {
        return localStorage.getItem(THEME_STORAGE_KEY) || 'default';
    } catch (error) {
        console.warn('Unable to read stored theme preference.', error);
        return 'default';
    }
}

export function applyTheme(theme) {
    if (!isBrowser()) return;
    const root = document.documentElement;
    if (!root) return;

    if (theme && theme !== 'default') {
        root.setAttribute('data-theme', theme);
    } else {
        root.removeAttribute('data-theme');
    }
}

export function setTheme(theme) {
    if (!isBrowser()) return;
    try {
        localStorage.setItem(THEME_STORAGE_KEY, theme);
    } catch (error) {
        console.warn('Unable to persist theme preference.', error);
    }
    applyTheme(theme);
}

export async function fetchThemeFromServer() {
    try {
        const response = await apiClient.get('/settings/theme');
        if (response.data && response.data.theme) {
            setTheme(response.data.theme);
            return response.data.theme;
        }
    } catch (error) {
        console.warn('Failed to fetch theme from server:', error);
    }
    return getStoredTheme();
}

export async function saveThemeToServer(theme) {
    try {
        await apiClient.put('/settings/theme', { theme });
        setTheme(theme);
    } catch (error) {
        console.error('Failed to save theme to server:', error);
        throw error;
    }
}

